import cx from "classnames";

import CopyFieldIcon from "components/CopyField/Icon";
import CardCollapsible from "ds/components/Card/Collapsible";
import TextEllipsis from "ds/components/TextEllipsis";
import Typography from "ds/components/Typography";
import { useToggle } from "hooks/useToggle";
import { RunWorkerMetricsStateError } from "types/generated";

import styles from "./styles.module.css";

type RunObservabilityErrorCardProps = {
  error: RunWorkerMetricsStateError;
  ariaLabel: string;
  initialIsCollapsed: boolean;
};

const RunObservabilityErrorCard = ({
  error: { message, resourceAddress },
  ariaLabel,
  initialIsCollapsed,
}: RunObservabilityErrorCardProps) => {
  const [isCollapsed, toggle] = useToggle(initialIsCollapsed);

  return (
    <CardCollapsible
      size="small"
      title="Error"
      titleSuffix={
        resourceAddress && (
          <TextEllipsis tooltip={resourceAddress}>
            {(ellipsisProps) => (
              <Typography
                {...ellipsisProps}
                tag="span"
                variant="p-body4"
                color="secondary"
                className={cx(ellipsisProps.className, styles.address)}
              >
                {resourceAddress}
              </Typography>
            )}
          </TextEllipsis>
        )
      }
      headerSuffix={<CopyFieldIcon title="Copy error" value={message} />}
      ariaLevel={4}
      ariaLabel={ariaLabel}
      isCollapsed={isCollapsed}
      onToggle={toggle}
    >
      <Typography tag="pre" variant="s-body3" className={styles.message}>
        {message}
      </Typography>
    </CardCollapsible>
  );
};

export default RunObservabilityErrorCard;
